import { string, object, ObjectSchema } from 'yup';

import supportsOneOf from 'helpers/supportsOneOf';

// This validation schemas is written for the PerformanceTrend/Audience Trend component

const periodTypeKeys = ['day', 'twoWeeks'];

/**
 * @returns {method} A yup schema to be used for validation
 */
function getSchema(): ObjectSchema<any> {
  const schema = object({
    selectedInterval: string().required().default('day'),
  });

  if (supportsOneOf()) {
    schema.fields.selectedInterval = schema.fields.selectedInterval.concat(
      string().oneOf(periodTypeKeys)
    );
  }

  return schema;
}

export default getSchema;
